// Preserve the existing account convention for UI access; API authorization remains server-owned.
export const canManageWorkspace = (user) => user?.username === 'Komoribe';
